import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ref } from "../../utilities/firebaseConfig";
import donesvg from "../../assets/homedoneicon.svg";
import wrkimg from "../../assets/workman.png";
import alisa from "../../assets/alisa.png";
import brandit from "../../assets/brandit.png";
import classic from "../../assets/classic.png";
import jamie from "../../assets/jamie.png";
import mockup from "../../assets/mockup.png";
import moonstar from "../../assets/moonstar.svg";
import newwave from "../../assets/newwave.png";
import organic from "../../assets/organic.png";
import outdoor from "../../assets/outdoor.png";
import resort from "../../assets/resort.png";
import showtime from "../../assets/showtime.png";
import sunshine from "../../assets/sunshine.png";
import servicess from "../../assets/services.jpg";
import reserve from "../../assets/reserve.jpg";
import jobdone from "../../assets/jobdone.jpg";
import { getDatabase, onValue } from "firebase/database";
import PostJob from "../../components/post_job/PostJob";
import Cookies from "../../components/cookies/Cookies";

import { IoIosMenu } from "react-icons/io";
function Homepage() {
  const [isVisible, setIsVisible] = useState(true);
  const [transparency, setTransparency] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [serviceType, setServiceType] = useState("");
  const [showSearchlist, setShowSearchlist] = useState(false);

  const [services, setServices] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCookie, setIsCookie] = useState(true);
  const [showNav, setShowNav] = useState(false);

  // Load data from localStorage on mount
  const didLoadData = useRef(false);

  // ✅ 1. Load from localStorage once on mount
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("formData"));
    if (storedData) {
      setServiceType(storedData.serviceType || "");
    }
    // ✅ Mark as loaded after restoring
    didLoadData.current = true;
  }, []);

  // ✅ 2. Save to localStorage anytime form data changes
  useEffect(() => {
    // ⛔ Skip saving on the very first load (to avoid overwriting)
    if (!didLoadData.current) return;

    const formData = {
      serviceType,
    };
    localStorage.setItem("formData", JSON.stringify(formData));
  }, [serviceType]);

  useEffect(() => {
    const db = getDatabase();
    const categoriesRef = ref(db, "categories");

    const unsubscribe = onValue(categoriesRef, (snapshot) => {
      const data = snapshot.val();
      const allServices = [];

      if (data) {
        Object.values(data).forEach((category) => {
          if (category.services) {
            Object.values(category.services).forEach((service) => {
              if (service.name) {
                allServices.push(service.name);
              }
            });
          }
        });
      }

      setServices(allServices);
    });

    return () => unsubscribe();
  }, []);

  // Filter items based on the search term
  const filteredItems = services.filter((item) =>
    item.toLowerCase().includes(serviceType.toLowerCase())
  );

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      if (currentScrollY > 104) {
        setTransparency(false);
      } else {
        setTransparency(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  return (
    <>
      <PostJob isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      <Cookies isOpen={isCookie} onClose={() => setIsCookie(false)} />

      <div className='homepage'>
        <div
          className={`navbar ${isVisible ? "visible" : "hidden"} ${
            transparency ? "transv" : "transn"
          }`}
        >
          <div className='navbar-logo-left'>
            <Link to='' className='navbar-logo'>
              ProfixExpress
            </Link>
            <div className='navbar-logo-middle'>
              <Link to='/client/signup' className='navbar-logo-link'>
                Services
              </Link>
              <Link to='/technician/signup' className='navbar-logo-link'>
                Become a technician
              </Link>
            </div>
          </div>

          <div className='navbar-logo-right'>
            <Link to='/login' className='navbar-logo-login navbar-logo-link'>
              Login
            </Link>
            <Link to='/client/signup' className='navbar-logo-become'>
              Sign up
            </Link>
          </div>

          <div className='alksh' onClick={() => setShowNav(true)}>
            <IoIosMenu className='lakshas' />
          </div>
        </div>
        <div className='divs'>
          <div class='lines'>
            <div class='line'></div>
            <div class='line'></div>
            <div class='line'></div>
          </div>

          <div class='content'>
            <div className='sectioncontainer'>
              <h1 className='sectionheadertitle'>
                Find Trusted ProfixExpress Services Near You
              </h1>
              <div className='thespace'></div>
              <p className='sectionheaderparagraph'>
                From plumbing to carpentry, book professional help with just a
                few taps
              </p>
              <div className='thespacee'></div>

              <div className='search-container'>
                <div className='src-input-search'>
                  <input
                    type='text'
                    placehdolder='What do you need help with?'
                    value={serviceType}
                    onChange={(e) => {
                      setServiceType(e.target.value);
                      setShowSearchlist(true);
                    }}
                  />
                  <button
                    className='searchbtn'
                    onClick={() => setModalOpen(true)}
                  >
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 24 24'
                      width='24'
                      height='24'
                      fill='rgba(255,255,255,1)'
                    >
                      <path d='M1.99974 13.0001L1.9996 11.0002L18.1715 11.0002L14.2218 7.05044L15.636 5.63623L22 12.0002L15.636 18.3642L14.2218 16.9499L18.1716 13.0002L1.99974 13.0001Z'></path>
                    </svg>
                  </button>
                </div>

                {showSearchlist && (
                  <>
                    <div
                      className='invisiblebackground'
                      onClick={() => setShowSearchlist(false)}
                    ></div>
                    <div className='src-input-searchcontainer'>
                      {filteredItems.length === 0 && (
                        <p>Sorry we don't offer this type of service.</p>
                      )}
                      {filteredItems.map((item, index) => (
                        <div className='searchitems'>
                          <p
                            key={index}
                            onClick={() => {
                              setServiceType(item);
                              setShowSearchlist(!showSearchlist);
                            }}
                          >
                            {item}
                          </p>
                          <svg
                            width='15'
                            height='15'
                            viewBox='0 0 15 15'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z'
                              fill='currentColor'
                              fill-rule='evenodd'
                              clip-rule='evenodd'
                            ></path>
                          </svg>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='divss'>
          <div className='content2'>
            <div className='sectioncontainer2'>
              <h1 className='sectioncontainertitle'>
                Comprehensive handyman service for every need
              </h1>
              <div className='thespace'></div>
              <p className='sectionheaderparagraph'>
                From fixing leaks to assembling furniture, explore a wide range
                of professional services designed to make your life easier.
                Whatever the task, we’ve got the right expert for you.
              </p>
            </div>
            <div className='thespacee'></div>
            <div className='sectioncontainer3'>
              <div className='sectioncontainer3-left'>
                <div className='sectioncontainer3-ltop'>
                  <h1 className='sltoptitle'>
                    Get someone proficient for your <span>Plumbing</span>{" "}
                    services
                  </h1>
                  <div className='thespacee'></div>
                  <div className='sltoplist'>
                    <div className='sltoplist-item'>
                      <img src={donesvg} alt='' className='sltopsvg' />
                      <p className='sltopparagraph'>Leak repairs</p>
                    </div>
                    <div className='sltoplist-item'>
                      <img src={donesvg} alt='' className='sltopsvg' />
                      <p className='sltopparagraph'>Pipe installations</p>
                    </div>
                    <div className='sltoplist-item'>
                      <img src={donesvg} alt='' className='sltopsvg' />
                      <p className='sltopparagraph'>Drain cleaning</p>
                    </div>
                    <div className='sltoplist-item'>
                      <img src={donesvg} alt='' className='sltopsvg' />
                      <p className='sltopparagraph'>
                        Faucet and shower repairs
                      </p>
                    </div>
                  </div>
                  <div className='thespacee'></div>
                  <div className='thespacee'></div>
                  <div className='sectioncontainer3-lbottom'>
                    <button className='slbottombutton'>Get started now</button>
                  </div>
                </div>
              </div>
              <div className='sectioncontainer3-right'>
                <img src={wrkimg} alt='' />
              </div>
            </div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='thetrustcnt'>
              <p className='therustpar'>
                Trusted by 20 Million Profixexpress users and leading brands
              </p>
              <div className='thespace'></div>
              <div class='slider'>
                <div className='slide-track'>
                  <div className='slide'>
                    <img src={alisa} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={brandit} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={classic} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={jamie} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={mockup} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={moonstar} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={newwave} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={organic} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={outdoor} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={resort} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={showtime} alt='' />
                  </div>
                  <div className='slide'>
                    <img src={sunshine} alt='' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='divss'>
          <div className='content3'>
            <div className='sectioncontainerfor'>
              <div className='sectioncontainerfor_left'>
                <div className='secconleftserv'>
                  <p className='seccontitle seconcolor'>Start from services</p>
                  <div className='thespace'></div>
                  <h1 className='sectitle'>Select a service</h1>
                  <div className='thespacee'></div>
                  <p className='sectpars'>
                    Choose from a wide range of home repair and maintenance
                    options.
                  </p>
                </div>
              </div>
              <div className='sectioncontainerfor_right'>
                <img src={servicess} alt='' />
              </div>
            </div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='sectioncontainerfor'>
              <div className='sectioncontainerfor_left'>
                <div className='secconleftserv'>
                  <p className='seccontitle seconcolors'>
                    The booking is yours
                  </p>
                  <div className='thespace'></div>
                  <h1 className='sectitle'>Book a technician</h1>
                  <div className='thespacee'></div>
                  <p className='sectpars'>
                    Pick a time that works for you and confirm the booking.
                  </p>
                </div>
              </div>
              <div className='sectioncontainerfor_right'>
                <img src={reserve} alt='' />
              </div>
            </div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
            <div className='sectioncontainerfor'>
              <div className='sectioncontainerfor_left'>
                <div className='secconleftserv'>
                  <p className='seccontitle seconcolorss'>
                    It's all about the job
                  </p>
                  <div className='thespace'></div>
                  <h1 className='sectitle'>Get the job done</h1>
                  <div className='thespacee'></div>
                  <p className='sectpars'>
                    Relax while our expert takes care of your task.
                  </p>
                </div>
              </div>
              <div className='sectioncontainerfor_right'>
                <img src={jobdone} alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showNav && (
        <div className='navcover'>
          <div className='theslahs'>
            <Link to='' className='iuaus'>
              ProfixExpress
            </Link>{" "}
            <button className='jkolan' onClick={() => setShowNav(false)} >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                width='24'
                height='24'
                fill='currentColor'
              >
                <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
              </svg>
            </button>
          </div>
          <div className="thespacee"></div>
          <div className='oieah'>
            <Link to='/client/signup' className=''>
              Services
            </Link>
            <Link to='/technician/signup' className=''>
              Become a technician
            </Link>
          </div>
          <div className="thespacee"></div>

          <div className='dividar'></div>
          <div className="thespacee"></div>
          <div className='iweya'>
            <Link to='/login' className=''>
              Login
            </Link>
            <Link to='/client/signup' className=''>
              Sign up
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Homepage;
